import { render, staticRenderFns } from "./AccessLog.vue?vue&type=template&id=2c2c0c08"
import script from "./AccessLog.vue?vue&type=script&lang=js"
export * from "./AccessLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports